import type { Ref } from 'vue';
import { DashboardReportFields } from '@/modules/Statistics/interfaces/DashboardReport';

export function useDashboardDragAndDrop(dashboardReports: Ref<DashboardReportFields[]>, isEditModeOn: Ref<boolean>) {
    function startDrag(event: any) {
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.effectAllowed = 'move';

        event.target.id = 'dragged';
    }

    function changeItemPosition(to: number, from: number) {
        if (!dashboardReports.value) {
            return;
        }
        const item = dashboardReports.value[from];

        dashboardReports.value.splice(from, 1);
        dashboardReports.value.splice(to, 0, item);
    }

    function findClosestContentItem(event: any, width: number) {
        let dropTarget;

        for (let i = 4; i > 1; i--) {
            const x = event.clientX - width / i - 50;
            const y = event.clientY;

            dropTarget = document.elementFromPoint(x, y)?.closest('.content-item');

            if (dropTarget) {
                return dropTarget;
            }
        }
    }

    function onDrop(event: any) {
        if (!isEditModeOn.value || !dashboardReports.value) {
            return;
        }

        let dropTarget;
        const droppedItem = document.getElementById('dragged');

        if (event.target.id === 'content-container') {
            // Get width of drop target
            const containerWidth = event.target.offsetWidth;

            // Locate closest content item if clicked outside of it
            dropTarget = findClosestContentItem(event, containerWidth);
        } else {
            dropTarget = event.target.closest('.content-item');
        }

        // Move dragged item
        if (dropTarget && droppedItem) {
            droppedItem.removeAttribute('id');

            // Get index of dropped item and drop target
            const dropTargetIndex = dropTarget.getAttribute('data-index');
            const droppedItemIndex = droppedItem.getAttribute('data-index');

            if (dropTargetIndex === droppedItemIndex) {
                return;
            }

            const toIndex = dashboardReports.value.findIndex((report) => report.id === dropTargetIndex);
            const fromIndex = dashboardReports.value.findIndex((report) => report.id === droppedItemIndex);

            changeItemPosition(toIndex, fromIndex);
        }
    }

    return {
        startDrag,
        onDrop,
    };
}
